export enum PractitionerDataErrorType {
    expiredAgb = 'expiredAgb',
    invalidAgb = 'invalidAgb',
    missingAgb = 'missingAgb',
    vektisNameMismatch = 'vektisNameMismatch',
}
